import type { Block } from "../../../models/ManualAuthoring";

/* ===== PARAGRAPH ===== */
import ParagraphView from "./pargraph/ParagraphView";
import ParagraphEdit from "./pargraph/ParagraphEdit";

/* ===== PARAGRAPH INDENTED ===== */
import ParagraphIndentedView from "./paragraphIndented/ParagraphIndentedView";
import ParagraphIndentedEdit from "./paragraphIndented/ParagraphIndentedEdit";

/* ===== SUBHEADING ===== */
import SubheadingView from "./subheading/SubheadingView";
import SubheadingEdit from "./subheading/SubheadingEdit";

/* ===== STEP ===== */
import StepView from "./step/StepView";
import StepEdit from "./step/StepEdit";

/* ===== SUBSTEP ===== */
import SubStepView from "./subStep/SubStepView";
import SubStepEdit from "./subStep/SubStepEdit";

/* ===== BULLET LIST ===== */
import BulletListView from "./bulletList/BulletListView";
import BulletListEdit from "./bulletList/BulletListEdit";

/* ===== NUMBER LIST ===== */
import NumberListView from "./numberList/NumberListView";
import NumberListEdit from "./numberList/NumberListEdit";

/* ===== NOTE ===== */
import NoteView from "./note/NoteView";
import NoteEdit from "./note/NoteEdit";

/* ===== WARNING ===== */
import WarningView from "./warning/WarningView";
import WarningEdit from "./warning/WarningEdit";

/* ===== CAUTION ===== */
import CautionView from "./caution/CautionView";
import CautionEdit from "./caution/CautionEdit";

/* ===== FIGURE ===== */
import FigureView from "./figure/FigureView";
import FigureEdit from "./figure/FigureEdit";

/* ===== TABLE ===== */
import TableView from "./table/TableView";
import TableEdit from "./table/TableEdit";

type BlockRendererProps = {
  block: Block;
  isEditing: boolean;
  figureNumber?: number;
  tableNumber?: number;
  stepNumber?: string;
  subStepLabel?: string;
  exitEditMode: () => void;
};

export default function BlockRenderer({
  block,
  isEditing,
  figureNumber,
  tableNumber,
  stepNumber,
  subStepLabel,
  exitEditMode,
}: BlockRendererProps) {

  switch (block.layout) {

    case "paragraph":
      return isEditing
        ? <ParagraphEdit block={block} onDone={exitEditMode} />
        : <ParagraphView block={block} />;

    case "paragraphIndented":
      return isEditing
        ? <ParagraphIndentedEdit block={block} onDone={exitEditMode} />
        : <ParagraphIndentedView block={block} />;

    case "subheading":
      return isEditing
        ? <SubheadingEdit block={block} onDone={exitEditMode} />
        : <SubheadingView block={block} />;

    case "step":
      return isEditing
        ? <StepEdit block={block} stepNumber={stepNumber} onDone={exitEditMode} />
        : <StepView block={block} stepNumber={stepNumber} />;

    case "subStep":
      return isEditing
        ? <SubStepEdit block={block} subStepLabel={subStepLabel} onDone={exitEditMode} />
        : <SubStepView block={block} subStepLabel={subStepLabel} />;

    case "bulletList":
      return isEditing
        ? <BulletListEdit block={block} onDone={exitEditMode} />
        : <BulletListView block={block} />;

    case "numberList":
      return isEditing
        ? <NumberListEdit block={block} onDone={exitEditMode} />
        : <NumberListView block={block} />;

    case "note":
      return isEditing
        ? <NoteEdit block={block} onDone={exitEditMode} />
        : <NoteView block={block} />;

    case "warning":
      return isEditing
        ? <WarningEdit block={block} onDone={exitEditMode} />
        : <WarningView block={block} />;

    case "caution":
      return isEditing
        ? <CautionEdit block={block} onDone={exitEditMode} />
        : <CautionView block={block} />;

    case "figure":
      return isEditing
        ? <FigureEdit block={block} figureNumber={figureNumber} onDone={exitEditMode} />
        : <FigureView block={block} figureNumber={figureNumber} />;

    case "table":
      return isEditing
        ? <TableEdit block={block} tableNumber={tableNumber} onDone={exitEditMode} />
        : <TableView block={block} tableNumber={tableNumber} />;

    default:
      return null;
  }
}
